import { AppGlobals } from '../AppGlobals';
import axios, { AxiosProgressEvent } from 'axios';

export class ZFileService {
    private zedxApiURL: string = process.env.REACT_APP_ZedX_Non_Odata_API!;

    constructor() { }

    public async uploadFile(module: string, file: File, onUploadProgress: (progressEvent: AxiosProgressEvent) => void): Promise<any> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('module', module);

        try {
            const uploadURL: string = `${this.zedxApiURL}/zfiles/upload`;

            const accessToken = await AppGlobals.acquireAccessToken();

            const response = await axios.post(uploadURL, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    UserId: AppGlobals.UserID,
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent: AxiosProgressEvent) => {
                    onUploadProgress(progressEvent);
                }
            });
            //console.log('File uploaded successfully', response.data);
            return response.data;
        } catch (error) {
            console.error('Error uploading file', error);
            throw error; // Rethrow the error to be handled by the caller
        }
    }

    public async downloadFile(fileUniqueID: string, fileName?: string): Promise<void> {
        try {
            const downloadURL: string = `${this.zedxApiURL}/zfiles/${fileUniqueID}`;
            const accessToken = await AppGlobals.acquireAccessToken();

            const response = await axios.get(downloadURL, {
                responseType: 'blob', // ALWAYS blob
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    UserId: AppGlobals.UserID
                }
            });

            const contentType = response.headers['content-type'];
            console.log('Content-Type of response:', contentType);

            // Case 1: Azure -> JSON response (SAS URL)
            if (contentType && contentType.includes('application/json')) {
                const text = await response.data.text();
                const data = JSON.parse(text);

                const link = document.createElement('a');
                link.href = data.url;
                link.style.display = 'none';

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                return;
            }

            // Case 2: Database -> actual file
            const blob = new Blob([response.data]);
            const fileUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', fileName || 'download');

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(fileUrl);

        } catch (error) {
            console.error('Error downloading file', error);
            throw error;
        }
    }

}